<div class="navbar-wrapper" data-dd-privacy="mask">
  @let langCode = languageCode();
  <sss-navbar-header [environment]="scopeEnvironmentName" [culture]="langCode">
    @if (environmentName === 'feature-prod') {
      <sss-navbar-tag left="true" class="feature-prod-tag">PROD</sss-navbar-tag>
    } @else if (environmentName !== 'prod') {
      <sss-navbar-tag left="true">{{ environmentName.toUpperCase() }}</sss-navbar-tag>
    }
    <sss-navbar-application-brand class="sss-navbar-separator">
      <span>{{ 'CHS_ChargingServices' | translate }}</span>
    </sss-navbar-application-brand>

    @if (environmentName === 'feature-prod') {
      <span class="feature-prod-warning">
        <tds-icon name="warning" size="16px" svg-title="" />
        Use with caution - this environment uses real production data
      </span>
    }

    <div class="sss-navbar-menu-divider"></div>

    <sss-navbar-help [environment]="scopeEnvironmentName" section="charging-services" />

    @if (isLoggedIn()) {
      <scope-banner [zindex]="1999999" />

      @if (langCode) {
        <sss-navbar-tour-header show-reset="true" />
      }

      <navbar-header-notifications
        label="{{ 'CHS_Notifications' | translate }}"
        heading="{{ 'CHS_Notifications' | translate }}"
        tabindex="0"
      >
        <notifications-container
          culturecode="{{ langCode }}"
          [environment]="scopeEnvironmentName"
          loggedin="true"
          systemname="ChargingServices"
        />
      </navbar-header-notifications>
    }
    <sss-navbar-app-launcher />
    <sss-navbar-account data-dd-privacy="mask"> </sss-navbar-account>
    <sss-navbar-brand />
  </sss-navbar-header>
</div>
